import axiosInstance from './axiosConfig';

// Tüm menü kategorilerini getir
export const getAllCategories = async () => {
  try {
    const response = await axiosInstance.get('/menu/categories');
    return response.data;
  } catch (error) {
    console.error('Menü kategorileri alınırken hata:', error);
    return {
      success: false,
      message: error.response?.data?.message || error.message || 'Kategoriler yüklenemedi',
      data: []
    };
  }
};

// Kategori detaylarını ve içindeki ürünleri getir
export const getCategoryWithItems = async (categoryId) => {
  try {
    const response = await axiosInstance.get(`/menu/categories/${categoryId}`);
    return response.data;
  } catch (error) {
    console.error(`Kategori ${categoryId} ürünleri alınırken hata:`, error);
    return {
      success: false,
      message: error.response?.data?.message || error.message || 'Kategori detayları yüklenemedi',
      data: { items: [] }
    };
  }
};

// ID'ye göre menü öğesi getir
export const getItemById = async (itemId) => {
  try {
    const response = await axiosInstance.get(`/menu/items/${itemId}`);
    return response.data;
  } catch (error) {
    console.error(`Menü öğesi ${itemId} alınırken hata:`, error);
    return {
      success: false,
      message: error.response?.data?.message || error.message || 'Menü öğesi yüklenemedi',
      data: null
    };
  }
};

// Öne çıkan menü ürünlerini getir
export const getFeaturedItems = async () => {
  try {
    const response = await axiosInstance.get('/menu/featured');
    return response.data;
  } catch (error) {
    console.error('Öne çıkan ürünler alınırken hata:', error);
    return {
      success: false,
      message: error.response?.data?.message || error.message || 'Öne çıkan ürünler yüklenemedi',
      data: []
    };
  }
};
